import { render } from "./VerPracticantes.vue?vue&type=template&id=13c94722"
import script from "./VerPracticantes.vue?vue&type=script&lang=js"
export * from "./VerPracticantes.vue?vue&type=script&lang=js"

import "./VerPracticantes.vue?vue&type=style&index=0&id=13c94722&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__